import Alice from "../../images/holidayIcons/Alice@2x.png";
import Barry from "../../images/holidayIcons/Barry@2x.png";
import Ben from "../../images/holidayIcons/Ben@2x.png";
import Chandler from "../../images/holidayIcons/Chandler@2x.png";
import Chloe from "../../images/holidayIcons/Chloe@2x.png";
import Emma from "../../images/holidayIcons/Emma@2x.png";
import Erica from "../../images/holidayIcons/Erica@2x.png";
import Estelle from "../../images/holidayIcons/Estelle@2x.png";
import Frank from "../../images/holidayIcons/FrankB@2x.png";
import Gunther from "../../images/holidayIcons/Gunther@2x.png";
import Janice from "../../images/holidayIcons/Janice@2x.png";
import Jill from "../../images/holidayIcons/Jill@2x.png";
import Joey from "../../images/holidayIcons/Joey@2x.png";
import Judy from "../../images/holidayIcons/Judy@2x.png";
import Leonard from "../../images/holidayIcons/Leonard@2x.png";
import Monica from "../../images/holidayIcons/Monica@2x.png";
import Pete from "../../images/holidayIcons/Pete@2x.png";
import Phoebe from "../../images/holidayIcons/Phoebe@2x.png";
import Rachel from "../../images/holidayIcons/Rachel@2x.png";
import Richard from "../../images/holidayIcons/Richard@2x.png";
import Rita from "../../images/holidayIcons/Rita@2x.png";
import Ross from "../../images/holidayIcons/Ross@2x.png";
import Roy from "../../images/holidayIcons/Roy@2x.png";
import Tag from "../../images/holidayIcons/Tag@2x.png";


const questions = [
  // [{
  //   id: 1,
  //   inNextQuestionSet: true,
  //   title: "Phoebe",
  //   desc: "Phoebe works as a part-time, self-employed masseuse. She has 3 clients scheduled this week.",
  //   answer: "yes",
  //   icon: Phoebe,
  //   wrongAnswerText:
  //     "Not quite! Phoebe is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population.",
  //   rightAnswerText:
  //     "Great job! Phoebe is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population.",
  // },
  // {
  //   id: 2,
  //   inNextQuestionSet: true,
  //   title: "Chandler",
  //   desc: "Chandler Bing recently quit his job in Tulsa in statistical analysis and data reconfiguration because he no longer wants to travel. He applies to a few jobs a month and eventually decides to apply for opportunities in advertising.",
  //   answer: "yes",
  //   icon: Chandler,
  //   wrongAnswerText:
  //     "Not quite! Chandler is over 16, and is neither in the military or institutionalized. He qualifies as being in the woking age population.",
  //   rightAnswerText:
  //     "Great job! Chandler is over 16, and is neither in the military or institutionalized. He qualifies as being in the woking age population.",
  // },
  // {
  //   id: 3,
  //   inNextQuestionSet: true,
  //   title: "Monica",
  //   desc: "Monica recently lost her job as a chef and has given up finding a new position. She currently spends her time volunteering as a fitness coach for Chandler Bing.",
  //   answer: "yes",
  //   icon: Monica,
  //   wrongAnswerText:
  //     "Not quite! Monica is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population.",
  //   rightAnswerText:
  //     "Great job! Monica is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population.",
  // },
  // {
  //   id: 4,
  //   inNextQuestionSet: true,
  //   title: "Rachel",
  //   desc: "Rachel just got fired from her job at Ralph Lauren after her boss caught her interviewing for a competing role at Gucci. Rachel doesn't land the job at Gucci but continues applying to fashion industry roles.",
  //   answer: "yes",
  //   icon: Rachel,
  //   wrongAnswerText: "Not quite! Rachel is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population.",
  //   rightAnswerText: "Great job! Rachel is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population.",
  // },
  // {
  //   id: 5,
  //   inNextQuestionSet: true,
  //   title: "Ross",
  //   desc: "Ross Geller is a paleontology professor at NYU.",
  //   answer: "yes",
  //   icon: Ross,
  //   wrongAnswerText:
  //     "Not quite! Ross  is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  //   rightAnswerText:
  //     "Great job! Ross  is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  // },
  // {
  //   id: 6,
  //   inNextQuestionSet: true,
  //   title: "Joey",
  //   desc: "Joey has no current paying acting roles, but has an audition lined up this week. He is preparing by taking French lessons from Phoebe.",
  //   answer: "yes",
  //   icon: Joey,
  //   wrongAnswerText:
  //     "Not quite! Joey is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  //   rightAnswerText:
  //     "Great job! Joey is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  // },
  // {
  //   id: 7,
  //   inNextQuestionSet: true,
  //   title: "Janice",
  //   desc: "Janice is a stay-at-home mom who is hoping to have a second child with her husband Sid.",
  //   answer: "yes",
  //   icon: Janice,
  //   wrongAnswerText:
  //     "Not quite! Janice is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population.",
  //   rightAnswerText:
  //     "Great job! Janice is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population.",
  // },
  // {
  //   id: 8,
  //   inNextQuestionSet: true,
  //   title: "Gunther",
  //   desc: "Gunther is the full-time Central Perk barista with a crush on Rachel.",
  //   answer: "yes",
  //   icon: Gunther,
  //   wrongAnswerText:
  //     "Not quite! Gunther is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  //   rightAnswerText:
  //     "Great job! Gunther is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  // },
  // {
  //   id: 9,
  //   inNextQuestionSet: false,
  //   title: "Ben",
  //   desc: "Ross's 7 year old son who enjoys playing pranks on Rachel.",
  //   answer: "no",
  //   icon: Ben,
  //   wrongAnswerText:
  //     "Not quite! Ben is under 16, so he does not meet the requirements to be in the working age population.",
  //   rightAnswerText:
  //     "Great job! Ben is under 16, so he does not meet the requirements to be in the working age population.",
  // },
  // {
  //   id: 10,
  //   inNextQuestionSet: true,
  //   title: "Frank Buffay Jr.",
  //   desc: "Frank Buffay Jr. has no known current profession and has not been looking for work. He is currently overwhelmed caring for triplets with his wife Alice.",
  //   answer: "yes",
  //   icon: Frank,
  //   wrongAnswerText:
  //     "Not quite! Frank is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  //   rightAnswerText:
  //     "Great job! Frank is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  // },
  // {
  //   id: 11,
  //   inNextQuestionSet: true,
  //   title: "Estelle Leonard",
  //   desc: "Estelle is Joey's agent. She works 10 hours a week to find her acting clients sub-par audition opportunities.",
  //   answer: "yes",
  //   icon: Estelle,
  //   wrongAnswerText:
  //     "Not quite! Estelle is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population.",
  //   rightAnswerText:
  //     "Great job! Estelle is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population.",
  // },
  // {
  //   id: 11,
  //   inNextQuestionSet: true,
  //   title: "Pete Becker",
  //   desc: "Pete recently sold his tech business and is spending all of his time on his hobby-training to be an ultimate fighter. He receives no money or endorsements for his fights.",
  //   answer: "yes",
  //   icon: Pete,
  //   wrongAnswerText:
  //     "Not quite! Pete is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  //   rightAnswerText:
  //     "Great job! Pete is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  // },
  // {
  //   id: 12,
  //   inNextQuestionSet: false,
  //   title: "Emma Geller-Green",
  //   desc: "Emma just turned one, and for her birthday Joey reads 'Love you Forever.'",
  //   answer: "no",
  //   icon: Emma,
  //   wrongAnswerText:
  //     "Not quite! Emma is under 16, so she does not meet the requirements to be considered part of the working age population.",
  //   rightAnswerText:
  //     "Great job! Emma is under 16, so she does not meet the requirements to be considered part of the working age population.",
  // },
  // {
  //   id: 13,
  //   inNextQuestionSet: true,
  //   title: "Alice Knight Geller",
  //   desc: "Alice is a 65 year old retired home economics teacher who is currently spending all of her time caring for triplets with her husband Frank.",
  //   answer: "yes",
  //   icon: Alice,
  //   wrongAnswerText:
  //     "Not quite! Alice is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population. There is no upper age limit for the working age population.",
  //   rightAnswerText:
  //     "Great job! Alice is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population. There is no upper age limit for the working age population.",
  // },
  // {
  //   id: 14,
  //   inNextQuestionSet: true,
  //   title: "Jill Green",
  //   desc: "Rachel's sister Jill Green has never held a job and has been cut off from spending her father's money. Ignoring Rachel's advice, she refuses to apply for jobs.",
  //   answer: "yes",
  //   icon: Jill,
  //   wrongAnswerText:
  //     "Not quite! Jill is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population.",
  //   rightAnswerText:
  //     "Great job! Jill is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population.",
  // },
  // {
  //   id: 15,
  //   inNextQuestionSet: true,
  //   title: "Leonard Green",
  //   desc: "Dr. Leonard Green, Rachel's father, is a cardiologist who refuses to retire after having a heart attack.",
  //   answer: "yes",
  //   icon: Leonard,
  //   wrongAnswerText:
  //     "Not quite! Dr. Green is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  //   rightAnswerText:
  //     "Great job! Dr. Green is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  // },
  // {
  //   id: 16,
  //   inNextQuestionSet: true,
  //   title: "Barry Farber",
  //   desc: "Barry is a full-time dentist, and owns his own practice. He married Rachel's maid of honor Mindy Hunter.",
  //   answer: "yes",
  //   icon: Barry,
  //   wrongAnswerText:
  //     "Not quite! Barry is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  //   rightAnswerText:
  //     "Great job! Barry is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  // },
  // {
  //   id: 17,
  //   inNextQuestionSet: true,
  //   title: "Tag Jones",
  //   desc: "Tag is a full time assistant at Ralph Lauren.",
  //   answer: "yes",
  //   icon: Tag,
  //   wrongAnswerText:
  //     "Not quite! Tag is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  //   rightAnswerText:
  //     "Great job! Tag is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  // },
  // {
  //   id: 18,
  //   inNextQuestionSet: true,
  //   title: "Judy Geller",
  //   desc: "Monica and Ross's mother is in her late 60s and has no known profession.",
  //   answer: "yes",
  //   icon: Judy,
  //   wrongAnswerText:
  //     "Not quite! Judy is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population. There is no upper age limit for the working age population.",
  //   rightAnswerText:
  //     "Great job! Judy is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population. There is no upper age limit for the working age population.",
  // },
  // {
  //   id: 19,
  //   inNextQuestionSet: false,
  //   title: "Rita O'Leary",
  //   desc: "A former roommate of Phoebe's, Rita is in prison for killing her husband.",
  //   answer: "no",
  //   icon: Rita,
  //   wrongAnswerText:
  //     "Not quite! Rita is institutionalized. She is in prison and therefore does not qualify as part of the working age population.",
  //   rightAnswerText:
  //     "Great job! Rita is institutionalized. She is in prison and therefore does not qualify as part of the working age population.",
  // },
  // {
  //   id: 20,
  //   inNextQuestionSet: true,
  //   title: "Chloe",
  //   desc: "Chloe works at a Xerox copy store, and has a romantic relationship with Ross (when Ross believes he and Rachel are 'on a break.')",
  //   answer: "yes",
  //   icon: Chloe,
  //   wrongAnswerText:
  //     "Not quite! Chloe is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population.",
  //   rightAnswerText:
  //     "Great job! Chloe is over 16, and is not in the military or institutionalized. She qualifies as being in the working age population.",
  // },
  // {
  //   id: 21,
  //   inNextQuestionSet: true,
  //   title: "Richard Burke",
  //   desc: "A retired opthalmologist who dates Monica for a time, and enjoys playing golf with Monica's father.",
  //   answer: "yes",
  //   icon: Richard,
  //   wrongAnswerText:
  //     "Not quite! Richard is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  //   rightAnswerText:
  //     "Great job! Richard is over 16, and is not in the military or institutionalized. He qualifies as being in the working age population.",
  // },
  // {
  //   id: 22,
  //   inNextQuestionSet: false,
  //   title: "Erica Bing",
  //   desc: "A twin, Erica is just days old when she moves with her parents, Chandler and Monica Bing, from NYC to Westchester.",
  //   answer: "no",
  //   icon: Erica,
  //   wrongAnswerText:
  //     "Not quite! Erica is under 16, and therefore is not old enough to qualify as part of the working age population.",
  //   rightAnswerText:
  //     "Great job! Erica is under 16, and therefore is not old enough to qualify as part of the working age population.",
  // },
  // {
  //   id: 23,
  //   inNextQuestionSet: false,
  //   title: "Roy Goodbody",
  //   desc: "Phoebe's former boyfriend who enlisted in the army. Roy is currently working on base in Fort Liberty, North Carolina.",
  //   answer: "no",
  //   icon: Roy,
  //   wrongAnswerText:
  //     "Not quite! Roy is enlisted in the military. Military personnel are not considered part of the working age population.",
  //   rightAnswerText:
  //     "Great job! Roy is enlisted in the military. Military personnel are not considered part of the working age population.",
  // }],
  [{
    id: 1,
    inNextQuestionSet: true,
    title: "Phoebe",
    desc: "Phoebe works as a part-time, self-employed masseuse. She has 3 clients scheduled this week.",
    answer: "yes",
    icon: Phoebe,
    wrongAnswerText:
      "Not quite! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
    rightAnswerText:
      "Great job! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
  },
  {
    id: 2,
    inNextQuestionSet: true,
    title: "Chandler",
    desc: "Chandler Bing recently quit his job in Tulsa in statistical analysis and data reconfiguration because he no longer wants to travel. He applies to a few jobs a month and eventually decides to apply for opportunities in advertising.",
    answer: "yes",
    icon: Chandler,
    wrongAnswerText:
      "Not quite! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
    rightAnswerText:
      "Great job! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
  },
  {
    id: 3,
    inNextQuestionSet: false,
    title: "Monica",
    desc: "Monica recently lost her job as a chef and has given up finding a new position. She currently spends her time volunteering as a fitness coach for Chandler Bing.",
    answer: "no",
    icon: Monica,
    wrongAnswerText:
      "Not quite! Monica is not actively applying for jobs, and therefore is not considered part of the labor force.",
    rightAnswerText:
      "Great job! Monica is not actively applying for jobs, and therefore is not considered part of the labor force.",
  },
  {
    id: 4,
    inNextQuestionSet: true,
    title: "Rachel",
    desc: "Rachel just got fired from her job at Ralph Lauren after her boss caught her interviewing for a competing role at Gucci. Rachel doesn't land the job at Gucci but continues applying to fashion industry roles.",
    answer: "yes",
    icon: Rachel,
    wrongAnswerText: "Not quite! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
    rightAnswerText: "Great job! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
  },
  {
    id: 5,
    inNextQuestionSet: true,
    title: "Ross",
    desc: "Ross Geller is a paleontology professor at NYU.",
    answer: "yes",
    icon: Ross,
    wrongAnswerText:
      "Not quite! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
    rightAnswerText:
      "Great job! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
  },
  {
    id: 6,
    inNextQuestionSet: true,
    title: "Joey",
    desc: "Joey has no current paying acting roles, but has an audition lined up this week. He is preparing by taking French lessons from Phoebe.",
    answer: "yes",
    icon: Joey,
    wrongAnswerText:
      "Not quite! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
    rightAnswerText:
      "Great job! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
  },
  {
    id: 7,
    inNextQuestionSet: false,
    title: "Janice",
    desc: "Janice is a stay-at-home mom who is hoping to have a second child with her husband Sid.",
    answer: "no",
    icon: Janice,
    wrongAnswerText:
      "Not quite! Although taking care of small children is hard work, Janice is not formally employed. She is not considered part of the labor force.",
    rightAnswerText:
      "Great job! Although taking care of small children is hard work, Janice is not formally employed. She is not considered part of the labor force.",
  },
  {
    id: 8,
    inNextQuestionSet: true,
    title: "Gunther",
    desc: "Gunther is the full-time Central Perk barista with a crush on Rachel.",
    answer: "yes",
    icon: Gunther,
    wrongAnswerText:
      "Not quite! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
    rightAnswerText:
      "Great job! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
  },
  // {
  //   id: 10,
  //   inNextQuestionSet: false,
  //   title: "Frank Buffay Jr.",
  //   desc: "Frank Buffay Jr. has no known current profession and has not been looking for work. He is currently overwhelmed caring for triplets with his wife Alice.",
  //   answer: "no",
  //   icon: Frank,
  //   wrongAnswerText:
  //     "Not quite! Frank is neither employed nor actively looking for formal, paid work, so he is not considered part of the labor force.",
  //   rightAnswerText:
  //     "Great job! Frank is neither employed nor actively looking for formal, paid work, so he is not considered part of the labor force.",
  // },
  {
    id: 11,
    inNextQuestionSet: true,
    title: "Estelle Leonard",
    desc: "Estelle is Joey's agent. She works 10 hours a week to find her acting clients sub-par audition opportunities.",
    answer: "yes",
    icon: Estelle,
    wrongAnswerText:
      "Not quite! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
    rightAnswerText:
      "Great job! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
  },
  {
    id: 11,
    inNextQuestionSet: false,
    title: "Pete Becker",
    desc: "Pete recently sold his tech business and is spending all of his time on his hobby: training to be an ultimate fighter. He receives no money or endorsements for his fights.",
    answer: "no",
    icon: Pete,
    wrongAnswerText:
      "Not quite! Pete is neither actively working or looking for paid, formal work. He is not considered part of the labor force.",
    rightAnswerText:
      "Great job! Pete is neither actively working or looking for paid, formal work. He is not considered part of the labor force.",
  },
  {
    id: 13,
    inNextQuestionSet: false,
    title: "Alice Knight Geller",
    desc: "Alice is a 65 year old retired home economics teacher who is currently spending all of her time caring for triplets with her husband Frank.",
    answer: "no",
    icon: Alice,
    wrongAnswerText:
      "Not quite! Alice is neither working nor actively looking for work. She is not considered part of the labor force.",
    rightAnswerText:
      "Great job! Alice is neither working nor actively looking for work. She is not considered part of the labor force.",
  },
  {
    id: 14,
    inNextQuestionSet: false,
    title: "Jill Green",
    desc: "Rachel's sister Jill Green has never held a job and has been cut off from spending her father's money. Ignoring Rachel's advice, she refuses to apply for jobs.",
    answer: "no",
    icon: Jill,
    wrongAnswerText:
      "Not quite! Jill is neither working nor looking for work. She is not considered part of the labor force.",
    rightAnswerText:
      "Great job! Jill is neither working nor looking for work. She is not considered part of the labor force.",
  },
  {
    id: 15,
    inNextQuestionSet: true,
    title: "Leonard Green",
    desc: "Dr. Leonard Green, Rachel's father, is a cardiologist who refuses to retire after having a heart attack.",
    answer: "yes",
    icon: Leonard,
    wrongAnswerText:
      "Not quite! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
    rightAnswerText:
      "Great job! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
  },
  {
    id: 16,
    inNextQuestionSet: true,
    title: "Barry Farber",
    desc: "Barry is a full-time dentist, and owns his own practice. He married Rachel's maid of honor Mindy Hunter.",
    answer: "yes",
    icon: Barry,
    wrongAnswerText:
      "Not quite! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
    rightAnswerText:
      "Great job! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
  },
  // {
  //   id: 17,
  //   inNextQuestionSet: true,
  //   title: "Tag Jones",
  //   desc: "Tag is a full time assistant at Ralph Lauren.",
  //   answer: "yes",
  //   icon: Tag,
  //   wrongAnswerText:
  //     "Not quite! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
  //   rightAnswerText:
  //     "Great job! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
  // },
  // {
  //   id: 18,
  //   inNextQuestionSet: false,
  //   title: "Judy Geller",
  //   desc: "Monica and Ross's mother is in her late 60s and has no known profession.",
  //   answer: "no",
  //   icon: Judy,
  //   wrongAnswerText:
  //     "Not quite! Judy is neither working nor actively looking for work. She is not considered part of the labor force.",
  //   rightAnswerText:
  //     "Great job! Judy is neither working nor actively looking for work. She is not considered part of the labor force.",
  // },
  {
    id: 20,
    inNextQuestionSet: true,
    title: "Chloe",
    desc: "Chloe works at a Xerox copy store, and has a romantic relationship with Ross (when Ross believes he and Rachel are 'on a break.')",
    answer: "yes",
    icon: Chloe,
    wrongAnswerText:
      "Not quite! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
    rightAnswerText:
      "Great job! Anyone in the working age population who is working or actively looking for work in the last 4 weeks qualifies as being part of the labor force.",
  },
  {
    id: 21,
    inNextQuestionSet: false,
    title: "Richard Burke",
    desc: "A retired opthalmologist who dates Monica for a time, and enjoys playing golf with Monica's father.",
    answer: "no",
    icon: Richard,
    wrongAnswerText:
      "Not quite! Richard is neither working nor looking for work. He is not considered part of the labor force.",
    rightAnswerText:
      "Great job! Richard is neither working nor looking for work. He is not considered part of the labor force.",
  }],
  [{
    id: 1,
    inNextQuestionSet: true,
    title: "Phoebe",
    desc: "Phoebe works as a part-time, self-employed masseuse. She has 3 clients scheduled this week.",
    answer: "yes",
    icon: Phoebe,
    wrongAnswerText:
      "Not quite! Anyone with paid employment is considered employed, including part-time workers, and self-employed workers.",
    rightAnswerText:
      "Great job! Anyone with paid employment is considered employed, including part-time workers, and self-employed workers.",
  },
  {
    id: 2,
    inNextQuestionSet: true,
    title: "Chandler",
    desc: "Chandler Bing recently quit his job in Tulsa in statistical analysis and data reconfiguration because he no longer wants to travel. He applies to a few jobs a month and eventually decides to apply for opportunities in advertising.",
    answer: "no",
    icon: Chandler,
    wrongAnswerText:
      "Not quite! Chandler has no current employment, and is looking for work. He is unemployed.",
    rightAnswerText:
      "Great job! Chandler has no current employment, and is looking for work. He is unemployed.",
  },
  {
    id: 4,
    inNextQuestionSet: true,
    title: "Rachel",
    desc: "Rachel just got fired from her job at Ralph Lauren after her boss caught her interviewing for a competing role at Gucci. Rachel doesn't land the job at Gucci but continues applying to fashion industry roles.",
    answer: "no",
    icon: Rachel,
    wrongAnswerText: "Not quite! Rachel has no current employment, and is actively looking for work. She is unemployed.",
    rightAnswerText: "Great job! Rachel has no current employment, and is actively looking for work. She is unemployed.",
  },
  {
    id: 5,
    inNextQuestionSet: true,
    title: "Ross",
    desc: "Ross Geller is a paleontology professor at NYU.",
    answer: "yes",
    icon: Ross,
    wrongAnswerText:
      "Not quite! Ross has a full-time job. He is considered employed.",
    rightAnswerText:
      "Great job! Ross has a full-time job. He is considered employed.",
  },
  {
    id: 6,
    inNextQuestionSet: true,
    title: "Joey",
    desc: "Joey has no current paying acting roles, but has an audition lined up this week. He is preparing by taking French lessons from Phoebe.",
    answer: "no",
    icon: Joey,
    wrongAnswerText:
      "Not quite! Joey has no current paid work, but he is actively seeking work. He is unemployed.",
    rightAnswerText:
      "Great job! Joey has no current paid work, but he is actively seeking work. He is unemployed.",
  },
  {
    id: 8,
    inNextQuestionSet: true,
    title: "Gunther",
    desc: "Gunther is the full-time Central Perk barista with a crush on Rachel.",
    answer: "yes",
    icon: Gunther,
    wrongAnswerText:
      "Not quite! Gunther has paid employment. He is employed.",
    rightAnswerText:
      "Great job! Gunther has paid employment. He is employed.",
  },
  {
    id: 11,
    inNextQuestionSet: true,
    title: "Estelle Leonard",
    desc: "Estelle is Joey's agent. She works 10 hours a week to find her acting clients sub-par audition opportunities.",
    answer: "yes",
    icon: Estelle,
    wrongAnswerText:
      "Not quite! Part-time workers are considered employed.",
    rightAnswerText:
      "Great job! Part-time workers are considered employed.",
  },
  {
    id: 15,
    inNextQuestionSet: true,
    title: "Leonard Green",
    desc: "Dr. Leonard Green, Rachel's father, is a cardiologist who refuses to retire after having a heart attack.",
    answer: "yes",
    icon: Leonard,
    wrongAnswerText:
      "Not quite! Dr. Green has a job as a cardiologist. He is employed.",
    rightAnswerText:
      "Great job! Dr. Green has a job as a cardiologist. He is employed.",
  },
  {
    id: 16,
    inNextQuestionSet: true,
    title: "Barry Farber",
    desc: "Barry is a full-time dentist, and owns his own practice. He married Rachel's maid of honor Mindy Hunter.",
    answer: "yes",
    icon: Barry,
    wrongAnswerText:
      "Not quite! Self-employed business owners who work more than 1 hour per week at their business are considered employed.",
    rightAnswerText:
      "Great job! Self-employed business owners who work more than 1 hour per week at their business are considered employed.",
  },
  // {
  //   id: 17,
  //   inNextQuestionSet: true,
  //   title: "Tag Jones",
  //   desc: "Tag is a full time assistant at Ralph Lauren.",
  //   answer: "yes",
  //   icon: Tag,
  //   wrongAnswerText:
  //     "Not quite! Tag has a job and is considered employed.",
  //   rightAnswerText:
  //     "Great job! Tag has a job and is considered employed.",
  // },
  {
    id: 20,
    inNextQuestionSet: true,
    title: "Chloe",
    desc: "Chloe works at a Xerox copy store, and has a romantic relationship with Ross (when Ross believes he and Rachel are 'on a break.')",
    answer: "yes",
    icon: Chloe,
    wrongAnswerText:
      "Not quite! Chloe has a job, and is considered employed.",
    rightAnswerText:
      "Great job! Chloe has a job, and is considered employed.",
  }],
  [{
    introduction: 'The Labor Force Participation Rate is found by dividing the number of people in the labor force by the adult population then multiplying by 100.',
    context: 'In this interactive, we found that 10 of our friends were in the labor force while 6 of our friends were not.',
    question: 'What is the labor force participation rate?',
    options: ['1.7%', '60%', '63%', '40%'],
    answer: '63%',
    inNextQuestionSet: true,
    answerDetail: {
      heading: 'The Labor Force Participation Rate is:',
      numinator: '10 friends in labor force',
      denuminator: '(10 friends in labor force + 6 friends not in the labor force)'

    }
  },
  {
    introduction: 'The Unemployment Rate is found by dividing the number of unemployed friends by the number of friends in the labor force then multiplying by 100.',
    context: 'In this interactive, we found that 7 of our friends were employed while 3 of our friends were not.',
    question: 'What is the Unemployment Rate?',
    options: ['43%', '30%', '2.3%', '19%'],
    answer: '30%',
    inNextQuestionSet: true,
    answerDetail: {
      heading: 'The Unemployment Rate is:',
      numinator: '3 unemployed friends',
      denuminator: '10 friends in the labor force <br/>(7 employed + 3 unemployed)'

    }
  }]
];

export default questions;
